import { formAddCsrfProtection } from "../../common/utils.js";

// Survey voting
export const ajaxSurvey = (form, is_embed = false) => {
	form.querySelector("._poll_error").innerHTML = "";
	formAddCsrfProtection(form).then((data) => {
		const formData = new FormData(form);
		fetch(form.getAttribute("action"), {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
			method: "POST",
			body: formData,
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.error) {
					form.querySelector("._poll_error").innerHTML =
						`<div class="alert alert-danger" role="alert">${data.error}</div>`;
				} else {
					if (is_embed) {
						window.location.reload();
					} else {
						const button = form.querySelector(
							"._submit_survey_form._poll_index",
						);
						button.parentNode.removeChild(button);
						for (const el of form.querySelectorAll("input")) {
							el.setAttribute("disabled", true);
						}
						for (const i of data.selected_choices) {
							form
								.querySelector(`input[value="${i}"]`)
								.setAttribute("checked", true);
						}
					}
				}
			})
			.catch((error) => {
				console.warn(" --- Error: ", error);
			});
	});
};
